module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[47]168.fa6ca04.woff2";